import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

export const selectFilteredComments = createSelector(
  (state: RootState) => state.tasksBoard.newComments,
  (newComments) => {
    const { comments, filter } = newComments;

    const unread = [...comments].filter((c) => !c.isViewed);

    if (filter === 'UNREAD') {
      return unread;
    }

    const read = [...comments].filter((c) => c.isViewed).sort((a, b) => a.viewedAt! - b.viewedAt!);

    if (filter === 'READ') {
      return read.reverse();
    }

    return [...unread, ...read];
  }
);
